// extracted by mini-css-extract-plugin
export var addButton = "AddInteracAccountStep-module--addButton--c4642";
export var autodepositLabel = "AddInteracAccountStep-module--autodepositLabel--4cb91";
export var autodepositNote = "AddInteracAccountStep-module--autodepositNote--9c9a2";
export var errorLearnMoreLink = "AddInteracAccountStep-module--errorLearnMoreLink--30d2c";
export var learnMoreLink = "AddInteracAccountStep-module--learnMoreLink--86a31";